import React, { Component } from 'react';
import momentJalaali from 'moment-jalaali';
import { calculateDuration, dayToName } from '../api/timeListProcess';
import Record from './recordComponent.jsx'
import Mergedrecord from './mergedRecord.jsx'

class Recordsofday extends Component {

  constructor(props){
    super(props)
    this.date = '';
    this.recordList = [];
    momentJalaali.loadPersian({dialect: 'persian-modern'})
  }

  initComp = (props, state) => {
    this.date = momentJalaali(props.date).format('dddd، jD jMMMM')
    this.duration = calculateDuration(props.times)
    this.records = [];
    const mergedTimes = dayToName(props.times)
    for( let key in mergedTimes){
      const time = mergedTimes[key]
      if(time.list.length < 2){
        this.records.push(<Record startSameRecord={props.startSameRecord} deleteRecord={props.deleteRecord} updateRecord={props.updateRecord} key={time.list[0].id} time={time.list[0]} />)
      }else{
        this.records.push(<Mergedrecord startSameRecord={props.startSameRecord} deleteRecord={props.deleteRecord} updateRecord={props.updateRecord} key={time.name+'--'+time.project.name} times={time} />)
      }
    }
  }

  componentWillReceiveProps = (nextProps, nextState)=>{
    this.initComp(nextProps, nextState)
  }

  componentWillMount = ()=>{
    this.initComp(this.props, this.state)
  }

  render() {
    return (
      <div className="records-block">
        <div className="records-header">
          <div className="pull-right">
            { this.date }
          </div>
          <div className="pull-left">
            <b>
              { this.duration }
            </b>
          </div>
        </div>
        <div className="records-body">
          {this.records}
        </div>
      </div>
    );
  }
}

Recordsofday.defaultProps = {
  date : '',
  times : []
}
export default Recordsofday;
